/* eslint-disable react/no-children-prop */
/* eslint-disable react/no-unstable-nested-components */
// React
import React, { Children, cloneElement, Component, Fragment } from 'react';
import { useDispatch, useSelector, connect } from 'react-redux';
import PropTypes from 'prop-types';
import { SLIDER_ID, types, actions as actionsUI } from '@/reducers/ui';

// Slider Lib
import SliderUI from 'react-slick';

// ClassNames and Styles
import cn from 'classnames';
import Icon, { ICON_ID } from '@gcloud-npm/next12.components.icon';
import CustomLink from '@gcloud-npm/next12.components.custom-link';
import { ICON_COLOR } from '@gcloud-npm/next12.components.icon-label';
import { actions } from '@gcloud-npm/next12.app-controller.reducers-sagas.modals-reducer';
// Components

const MAIN_TAGGING_INFO = {
  componentProduct: 'alarmas',
  componentName: '',
  componentVariation: 'all',
  componentContent: '',
  componentePerso: '',
};

const ArrowBack = ({ slideToGo }) => {
  const dispatch = useDispatch();
  return (
    <>
      <div className="chevron">
        <CustomLink
          taggingInfo={{
            ...MAIN_TAGGING_INFO,
            componentName: '',
            componentContent: '',
          }}
          onClick={() => {
            dispatch(
              actionsUI.setActiveSlide({
                sliderId: SLIDER_ID.Prueba,
                slideIndex: slideToGo,
              })
            );
            console.log(`desde click de flecha tenemos que ir a: ${slideToGo}`);
          }}
          // setActiveSlide(slideToGo);
        >
          <Icon id={ICON_ID.CheuronLeft} color={ICON_COLOR.BLUE_A} size={30} />
        </CustomLink>
      </div>
      <style jsx>
        {`
          .chevron {
            position: absolute;
            top: 50%;
            left: 0px;
            z-index: 1;
            background-color: white;
            padding: 0.3rem;
            box-shadow: var(--color-gp--grey4) 0px 2px 5px;
            border-radius: 100%;
            -webkit-transform: translate(0, -50%);
            -ms-transform: translate(0, -50%);
            transform: translate(0, -50%);
          }
        `}
      </style>
    </>
  );
};

const ArrowForward = ({ slideToGo }) => {
  const dispatch = useDispatch();
  return (
    <>
      <div className="chevron">
        <CustomLink
          taggingInfo={{
            ...MAIN_TAGGING_INFO,
            componentName: '',
            componentContent: '',
          }}
          onClick={() => {
            dispatch(
              actionsUI.setActiveSlide({
                sliderId: SLIDER_ID.Prueba,
                slideIndex: slideToGo,
              })
            );
            console.log(`desde click de flecha tenemos que ir a: ${slideToGo}`);
          }}
        >
          <Icon id={ICON_ID.CheuronRight} color={ICON_COLOR.BLUE_A} size={30} />
        </CustomLink>
      </div>
      <style jsx>
        {`
          .chevron {
            position: absolute;
            top: 50%;
            left: 97%;
            z-index: 2;
            background-color: white;
            padding: 0.3rem;
            box-shadow: #000 0px 2px 5px;
            border-radius: 100%;
            -webkit-transform: translate(0, -50%);
            -ms-transform: translate(0, -50%);
            transform: translate(0, -50%);
          }
        `}
      </style>
    </>
  );
};

/**
 * @name Slider
 * @description minimal slider
 * @see {@link https://react-slick.neostack.com}
 * @param {any} props
 * @param {React.Ref} ref
 * @returns {React.FC}
 */

class Slider extends Component {
  constructor(props) {
    super(props);
    const { activeSlide } = props;
    this.state = {
      activeSlide,
    };
  }
  componentDidUpdate(prevProps, prevState) {
    // const { sliderId, sliders: currentSliders } = this.props;
    // const { sliders: prevSliders } = prevProps;

    this._slick.slickGoTo(this.props.activeSlide);
  }

  setActiveSlide = (indexToGo) => {
    if (this._slick && this._slick.slickGoTo) {
      this._slick.slickGoTo(indexToGo);
      this.setState({
        activeSlide: indexToGo,
      });
    }
  };

  onSwipe = (movement) => {
    if (this.props.className === 'bottom-slider') {
      if (movement === 'left') {
        this.props.dispatchSubmitData(
          SLIDER_ID.Prueba,
          this.props.activeSlide + 1
        );
      } else {
        this.props.dispatchSubmitData(
          SLIDER_ID.Prueba,
          this.props.activeSlide - 1
        );
      }
    }
  };

  onBeforeChange = (oldIndex, newIndex) => {
    // vemos si recibo una desde mi papi
    const { onBeforeChange } = this.props;
    if (onBeforeChange) {
      // ejecuto la función que desde mi page(padre) y le actualizo el index de esta forma el nuevo indice llega a la a la vistasuperior
      onBeforeChange(newIndex);
    }
    // this.setState(
    //   {
    //     activeSlide: newIndex,
    //   },
    //   () => {
    //     console.log(`Solicito un cambio a: ${this.state.activeSlide}`);
    //   }
    // );
  };

  render() {
    const { children } = this.props;
    const items2Render = Children.toArray(children);

    let slidesToShow = items2Render.length;
    const { slidesToShow: slidesToShowProp } = this.props;
    if (slidesToShow) {
      slidesToShow = slidesToShowProp;
    }

    const {
      slidesToScroll = 1,
      arrows = true,
      infinite = false,
      responsive = [],
      className,
      style: styleProp = {},
      gutter = 0,
      lazyLoad = false,
      dots = true,
      disabled = false,
      swipeToSlide = false,
      swipe = false,
      initialSlide = 0,
      variableWidth = false,
      centerMode = false,
      centerPadding = `24px`,
      prevArrow = (
        <ArrowBack
          slideToGo={this.props.activeSlide - 1}
          // setActiveSlide={    this._slick.slickGoTo(this.props.activeSlide);
        />
      ),
      nextArrow = (
        <ArrowForward
          slideToGo={this.props.activeSlide + 1}
          // setActiveSlide={this.setActiveSlide}
        />
      ),
      tagInfo: tagInfoProp = {},
      setActiveSlide,
    } = this.props;
    const baseTagInfo = {
      componentName: 'Slider',
      componentVariation: 'all',
      ...tagInfoProp,
    };

    return (
      <SliderUI
        className={cn('slider', { 'slider--disabled': disabled }, className)}
        ref={function (c) {
          this._slick = c;
        }.bind(this)}
        style={{
          marginLeft: -gutter,
          marginRight: -gutter,
          paddingLeft: gutter,
          paddingRight: gutter,
          ...styleProp,
        }}
        lazyLoad={lazyLoad}
        infinite={infinite}
        dots={dots}
        swipeToSlide={swipeToSlide}
        swipe={swipe}
        initialSlide={initialSlide}
        slidesToShow={slidesToShow}
        slidesToScroll={slidesToScroll}
        variableWidth={variableWidth}
        centerMode={centerMode}
        centerPadding={centerPadding}
        prevArrow={prevArrow}
        nextArrow={nextArrow}
        customPaging={(i) => <span key={`dot${i}`}>{i}</span>}
        responsive={responsive}
        arrows={arrows}
        onSwipe={this.onSwipe}
        setActiveSlide={setActiveSlide}
        beforeChange={this.onBeforeChange}
      >
        {items2Render.map((child, index) => (
          <Fragment key={`${index.toString()}-item`}>
            {cloneElement(child, {
              onClick: () => {
                if (this.props.onclick != null) this.props.onclick(key);
              },
              slickGoTo: () => {
                this.setActiveSlide(key);
              },
            })}
          </Fragment>
        ))}
      </SliderUI>
    );
  }
}

Slider.propTypes = {
  activeSlide: PropTypes.number,
  slidesToShow: PropTypes.number,
};

Slider.defaultProps = {
  activeSlide: 0,
  slidesToShow: 0,
};

// export default Slider;

const mapStateToProps = (state) => ({
  ui: state.ui,
});

function mapDispatchToProps(dispatch) {
  return {
    dispatchSubmitData: (sliderId, slideIndex) =>
      dispatch(actionsUI.setActiveSlide({ sliderId, slideIndex })),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Slider);
